<template>
  <div class="grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-2 mb-2 md:mb-4 last-child:mb-0">
    <template
      v-for="filter in LessonFilters"
      :key="filter.facet"
    >
      <AisMenuSelect
        :attribute="filter.facet"
        :limit="1000"
        :sort-by="['alpha:asc']"
        :transform-items="transformMenuItems"
        :class-names="{
          'ais-MenuSelect': 'w-full',
        }"
      >
        <template #default="{ items, canRefine, refine }">
          <button
            v-if="items.some(e => e.isRefined)"
            class="py-2.5 px-3.5 btn btn--blue rounded-lg w-full justify-between min-w-fit text-left"
            @click="refine('')"
          >
            {{ items.find((e: FacetValue) => e.isRefined).label }}
            <SvgIcon
              aria-hidden="true"
              icon-name="close"
              width="20"
              height="20"
            />
          </button>
          <select
            v-else
            :disabled="!canRefine"
            :aria-disabled="!canRefine"
            :aria-label="filter.label"
            @change="refine($event.currentTarget?.value)"
          >
            <option value="">
              {{ filter.label }}
            </option>
            <option
              v-for="item in items"
              :key="item.value"
              :value="item.value"
              :selected="item.isRefined"
            >
              {{ item.label }} ({{ item.count }})
            </option>
          </select>
        </template>
      </AisMenuSelect>
    </template>
  </div>
</template>

<script lang="ts">
export default { name: 'LessonFilters' }
</script>

<script setup lang="ts">
import { AisMenuSelect } from 'vue-instantsearch/vue3/es'
import { FacetValue } from '~/types/globals/FacetValue'
import { toTitleCase } from '~/lib/string'
import LessonFilters from '~/constants/LessonFilters'

const transformMenuItems = (items: FacetValue[]) => {
  return items.map((item) => {
    return {
      ...item,
      label: toTitleCase(item.label),
    }
  })
}

</script>
